export default {
  handleRefresh () {
    this.data = [[], 0]
    this.query = Object.assign({}, this.query, { page: 1, search: [] })
    this.getList()
  },
  async getList () {
    try {
      this.handleCancelToken()
      this.loading = true
      this.query.name = this.name
      const CancelToken = this.axios.CancelToken
      this.data = (await this.axios.get(this.listApiUrl, {
        cancelToken: new CancelToken((c) => { this.cancel = c }),
        params: this.query
      })).data
      this.loading = false
    } catch (err) {
      this.handleError(err)
      if (!this.axios.isCancel(err)) {
        this.data = [[], 0]
        this.loading = false
      }
    }
  },
  handleCancelToken () {
    if (this.loading && this.cancel) {
      this.cancel()
    }
  },
  handleSearch () {
    this.query.page = 1
    this.getList()
  },
  handleChangePage (val) {
    this.query.page = val
    this.getList()
  },
  handleChangeLimit (val) {
    this.query.page = 1
    this.query.limit = val
    this.getList()
  }
}
